import { render, staticRenderFns } from "./station.vue?vue&type=template&id=e96c31b0&scoped=true"
import script from "./station.vue?vue&type=script&lang=js"
export * from "./station.vue?vue&type=script&lang=js"
import style0 from "./station.vue?vue&type=style&index=0&id=e96c31b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c31b0",
  null
  
)

export default component.exports